const orderPaymentMngt = {
    namespaced: true,
    state : {
        prescribeSeq : '',
        clinicDoctorClass : ''
        
    },
    getters: {
        getPrescribeSeq (state) {
            return state.prescribeSeq
        }
    },
    mutations: {
        setPrescribeSeq (state, payload) {
            state.prescribeSeq = payload
        }
    },
    actions: {
        setPrescribeSeq ({commit}, payload) {
            commit('setPrescribeSeq', payload)
        },
        setOrderPaymentInit ({commit}) {
            commit('setPrescribeSeq', '');
        },
    }
}


export default orderPaymentMngt